import React from 'react';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { Product } from '../data/mockProducts';
export interface CartItem {
  product: Product;
  quantity: number;
}
interface CartState {
  items: CartItem[];
  addToCart: (product: Product) => void;
  removeFromCart: (productId: string) => void;
  updateQuantity: (productId: string, quantity: number) => void;
  clearCart: () => void;
  totalItems: number;
  totalPrice: number;
}
export const useCart = create<CartState>()(persist((set, get) => ({
  items: [],
  addToCart: product => {
    const items = get().items;
    const existingItem = items.find(item => item.product.id === product.id);
    if (existingItem) {
      set({
        items: items.map(item => item.product.id === product.id ? {
          ...item,
          quantity: item.quantity + 1
        } : item)
      });
    } else {
      set({
        items: [...items, {
          product,
          quantity: 1
        }]
      });
    }
  },
  removeFromCart: productId => {
    set({
      items: get().items.filter(item => item.product.id !== productId)
    });
  },
  updateQuantity: (productId, quantity) => {
    if (quantity <= 0) {
      get().removeFromCart(productId);
      return;
    }
    set({
      items: get().items.map(item => item.product.id === productId ? {
        ...item,
        quantity
      } : item)
    });
  },
  clearCart: () => set({
    items: []
  }),
  get totalItems() {
    return get().items.reduce((sum, item) => sum + item.quantity, 0);
  },
  get totalPrice() {
    return get().items.reduce((sum, item) => sum + item.product.price * item.quantity, 0);
  }
}), {
  name: 'cart-storage'
}));